import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const IdXboxGameInfoDashboard = loadable(() =>
  withDefaultLoaderModifiers(
    import(/* webpackChunkName: "IdXboxGameInfoDashboard" */ "./IdXboxGameInfoDashboard")
  )
);
